import { render, staticRenderFns } from "./ReminderVersion.vue?vue&type=template&id=86cb1cc4&"
import script from "./ReminderVersion.vue?vue&type=script&lang=js&"
export * from "./ReminderVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports